import React from 'react';
import PropTypes from 'prop-types';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';
import { parseDate } from 'utils/date';
import './PortfolioUpdateModalHeader.less';
import { api } from 'api';

export default function PortfolioUpdateModalHeader({ monitorId }) {
  const [data, setData] = React.useState([]);
  const { t } = useLocale();
  React.useEffect(() => {
    api.monitor.loadMonitorOverview(monitorId).then((res) => {
      setData(res);
    });
  }, []);
  return (
    <div className="portfolio-update-header grid collapse720">
      <div className="col s1of3">
        <div className="update-header-label">{t('portfolioUpdateHeader_count')}</div>
        <div className="update-header-content">
          {data ? (
            <span>
              {data.keywordCount} aðilar ({data.watchListLimit})
            </span>
          ) : (
            '?'
          )}
        </div>
      </div>
      <div className="col s1of3">
        <div className="update-header-label">{t('portfolioUpdateHeader_lastNotification')}</div>
        <div className="update-header-content">{data ? parseDate(data.lastNotification) : '?'}</div>
      </div>
      <div className="col s1of3">
        <div className="update-header-label">{t('portfolioUpdateHeader_lastUpdate')}</div>
        <div className="update-header-content">{data ? parseDate(data.lastKeywordAdded) : '?'}</div>
      </div>
    </div>
  );
}

PortfolioUpdateModalHeader.propTypes = {
  monitorId: PropTypes.number.isRequired,
};
